import { AuthProvider } from "react-admin";

/**
 * Simple Auth Provider for React Admin
 *
 * KISS: Минимум логики, работает с токеном в localStorage
 * AuthGuard отвечает за redirect на login
 */
export const authProvider: AuthProvider = {
  // Login не используется напрямую - OAuth делает редирект
  login: async () => Promise.resolve(),

  logout: async () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    window.location.href = "/login";
    return Promise.resolve();
  },

  checkAuth: async () => {
    const token = localStorage.getItem("token");
    if (!token) {
      return Promise.reject();
    }
    return Promise.resolve();
  },

  checkError: async (error) => {
    // Только 401 = невалидный токен
    if (error?.status === 401) {
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      return Promise.reject();
    }
    return Promise.resolve();
  },

  getIdentity: async () => {
    const userStr = localStorage.getItem("user");
    if (!userStr) {
      return Promise.reject();
    }
    const user = JSON.parse(userStr);
    return Promise.resolve({
      id: user.id,
      fullName: user.name || user.email,
      avatar: user.avatarUrl,
    });
  },

  getPermissions: async () => {
    const userStr = localStorage.getItem("user");
    if (!userStr) return Promise.resolve([]);

    const user = JSON.parse(userStr);
    return Promise.resolve(user.roles || []);
  },
};
